import { useState } from 'react';
import cn from 'classnames';
import { MdOpenInNew, MdVisibility, MdWarning } from 'react-icons/md';
import { InteractiveSpan } from '@Components/InteractiveEl';
import { CreativeThumb, MetricGrid, RecBox, SectionCard, SrcCue, Tag } from './CreativeSuiteShared';
import { CreativeGalleryModal } from './CreativeGalleryModal';
import {
  DIVERSITY_METRICS,
  DIVERSITY_RECS,
  DIVERSITY_ROWS,
  DiversityRow
} from './creativeSuite-constants';

const ConcentrationTag = ({ row }: { row: DiversityRow }) => (
  <Tag variant={row.risk} icon={row.risk === 'red' ? <MdWarning aria-hidden /> : undefined}>
    {row.concentrationTag}
  </Tag>
);

const DiversityTableRow = ({ row }: { row: DiversityRow }) => (
  <tr>
    <td>
      <span className='nm'>{row.adset}</span>
      <div className='cell-tag'>
        <ConcentrationTag row={row} />
      </div>
    </td>
    <td>
      <span className={cn('div-score', row.risk)}>{row.diversity}</span>
    </td>
    <td>
      <span className='nm'>{row.spend}</span>
    </td>
    <td>{row.roas}</td>
    <td>{row.ctr}</td>
    <td>{row.cpa}</td>
    <td>
      <span className='thumb-stack'>
        {row.creatives.map((kind, i) => (
          <CreativeThumb key={`${row.adset}-${kind}-${i}`} kind={kind} small />
        ))}
      </span>
    </td>
  </tr>
);

export const DiversityView = () => {
  const [galleryOpen, setGalleryOpen] = useState(false);

  return (
    <div className='bp-panel'>
      <MetricGrid metrics={DIVERSITY_METRICS} columns={3} />

      <SectionCard
        title='Low diversity · high spend'
        sub='Ranked by spend exposure'
        right={<SrcCue />}
      >
        <table className='bp-table'>
          <thead>
            <tr>
              <th>Ad set</th>
              <th>Diversity</th>
              <th>Spend</th>
              <th>ROAS</th>
              <th>CTR</th>
              <th>CPA</th>
              <th>Creatives</th>
            </tr>
          </thead>
          <tbody>
            {DIVERSITY_ROWS.map(row => (
              <DiversityTableRow key={row.adset} row={row} />
            ))}
          </tbody>
        </table>

        <div className='card-actions'>
          <InteractiveSpan className='mini-btn primary' onClick={() => setGalleryOpen(true)}>
            <MdVisibility aria-hidden /> View creatives
          </InteractiveSpan>
          <InteractiveSpan className='mini-btn'>
            <MdOpenInNew aria-hidden /> Open in Ads Manager
          </InteractiveSpan>
        </div>

        {DIVERSITY_RECS.map(rec => (
          <RecBox key={rec.title} rec={rec} />
        ))}
      </SectionCard>

      <CreativeGalleryModal show={galleryOpen} onHide={() => setGalleryOpen(false)} />
    </div>
  );
};
